import { FlowioThunkCreator } from "../../types";

import * as AC from "../actionCreators";
import * as S from "../selectors";
import * as R from "../../../requests/impersonation/requestCreators";

type ThunkCreator = FlowioThunkCreator<void>;

export const isImpersonating: ThunkCreator = () => (dispatch, getState) =>
  Promise.resolve().then(async () => {
    const isFetching = S.getIsImpersonationFetching(getState());
    if (isFetching) return;

    dispatch(AC.isImpersonatingRequest());

    try {
      const response = await R.isImpersonating();
      dispatch(AC.isImpersonatingSuccess({ userId: response.data }));
    } catch (e) {
      dispatch(AC.isImpersonatingError());
    }
  });

export type IsImpersonating = ThunkCreator;
